import {useEffect, useState} from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm'
import axios from "axios";
import { MarkdownContainer } from "@/components/ui/MarkdownContainer.tsx";

export const HandbookPage = () => {
    const [content, setContent] = useState('');

    const getContent = async () => {
        const { data } = await axios.get('https://api.assistantlab.ru/doc.md');
        setContent(data)
    }

    useEffect(() => {
        getContent()
    }, []);

    return (
        <MarkdownContainer>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {content}
            </ReactMarkdown>
        </MarkdownContainer>
    )
}
